import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=12ef9e3f&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=12ef9e3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef9e3f",
  null
  
)

export default component.exports